export default __webpack_public_path__ + "assets/images/d9a38b1957a08e096511f55307e86b3c.svg";